import { Box, ContainerProps, SxProps, Theme } from '@mui/material';
import { DistribuidorCenterContainer } from '@/components/blocks/DistribuidorCenterContainer';

interface DpContainerProps extends ContainerProps {
	framesx?: SxProps<Theme>;
}

export const DpBenefitsContainer: React.FC<React.PropsWithChildren<DpContainerProps>> = ({
	children,
	component,
	framesx,
	...props
}) => (
	<Box component={component} width="100vw" display="flex" justifyContent="center" sx={framesx}>
		<DistribuidorCenterContainer {...props}>{children}</DistribuidorCenterContainer>
	</Box>
);
